module.exports = __webpack_public_path__ + "static/img/ARADIN2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARADIN2_1.png
// module id = 4C5Z
// module chunks = 0